import React, {Component,useState} from "react";
import Leftmenu from "../element/leftmenu";
import Header from "../element/header";
import PageBreadcrumb from "../element/pagebreadcrumb";
import {DeleteOutlined, DownloadOutlined} from "@ant-design/icons";
import {
    Layout,
    Col,
    Row,
    PageHeader,
    Button,
    Descriptions,
    Typography,
    InputNumber,
    Slider,
    Input,
    Space,
    DatePicker,
    Table, Popconfirm
} from 'antd';
import 'moment/locale/zh-cn';
import cookie from "react-cookies";
const { Title,Text } = Typography;
const { Content } = Layout;

const DecimalStep = () => {
    const [inputValue, setInputValue] = useState(0);
    const onChange = (value) => {
        if (isNaN(value)) {
            return;
        }
        setInputValue(value);
    };
    return (
        <Row>
            <Col span={12}>
                <Slider
                    min={0}
                    max={10}
                    onChange={onChange}
                    value={typeof inputValue === 'number' ? inputValue : 0}
                    step={0.01}
                />
            </Col>
            <Col span={4}>
                <InputNumber
                    min={0}
                    max={10}
                    style={{
                        margin: '0 16px',
                    }}
                    step={0.01}
                    value={inputValue}
                    onChange={onChange}
                />
            </Col>
        </Row>
    );
};
const onChange = (date, dateString) => {
    console.log(date, dateString);
};
const onGo = () => {
    window.location.href="/pagebuildassayed";
};
const onGo2 = (id) => {
    window.open("/pagebuildassayr?id=" + id);
};
const Delete = (id) => {
    const [open, setOpen] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const showPopconfirm = () => {
        setOpen(true);
    };
    const handleOk = () => {
        setConfirmLoading(true);
        setTimeout(() => {
            setOpen(false);
            setConfirmLoading(false);

            fetch("https://pd.pokemonbye.com:8084/api/setsellassaystate?state=0&id=" + id.id)
                .then(res => res.json())
                .then(
                    (result) => {
                        window.location.reload()

                    },
                    (error) => {
                    }
                )
        }, 1000);
    };
    const handleCancel = () => {
        setOpen(false);
    };
    return (
        <Popconfirm
            title="删除后将不可恢复"
            open={open}
            onConfirm={handleOk}
            okButtonProps={{
                loading: confirmLoading,
            }}
            onCancel={handleCancel}
        >
            <Button  onClick={showPopconfirm}>
                删除
            </Button>
        </Popconfirm>
    );
};
const columns = [
    {
        title: '序号',
        dataIndex: 'key',
        key: 'key',
    },
    {
        title: '编号',
        dataIndex: 'assay_num',
        key: 'assay_num',
    },
    {
        title: '品名',
        dataIndex: 'stocktype_name',
        key: 'stocktype_name',
    },
    {
        title: '细度',
        dataIndex: 'assay_F',
        key: 'assay_F'
    },
    {
        title: '需水量比',
        dataIndex: 'assay_h2o',
        key: 'assay_h2o'
    },
    {
        title: '三氧化硫',
        dataIndex: 'assay_so3',
        key: 'assay_so3'
    },
    {
        title: '游离氧化钙',
        dataIndex: 'assay_cl',
        key: 'assay_cl'
    },
    {
        title: '烧失量',
        dataIndex: 'assay_loi',
        key: 'assay_loi'
    },
    {
        title: '强度活性指数',
        dataIndex: 'assay_na2o',
        key: 'assay_na2o',
        render: (assay_na2o) => <>{assay_na2o === "0.0" ? "/" : assay_na2o}</>,
    },
    {
        title: '检验日期',
        dataIndex: 'assay_date',
        key: 'assay_date',
    },
    {
        title: '发布日期',
        dataIndex: 'assay_pubtime',
        key: 'assay_pubtime',
    },
    {
        title: '功能',
        key: 'action',
        render: (_, record) => (
            <Space size="middle">
                <Button onClick={() => onGo2(record.assay_date)}>报告</Button>
                <Delete id={record.assay_id}></Delete>
            </Space>
        ),
    },
];

class PageBuildAssay extends Component{


    constructor(props) {
        super(props);
        const userid = cookie.load('userId');
        this.state = {
            title: "化验报告",
            county: [],
            userid: userid,
            list: []
        };
    }

    componentDidMount() {
        fetch("https://pd.pokemonbye.com:8084/api/getsellbuildassaybyunit")
            .then(res => res.json())
            .then(
                (result) => {
                    let array = result.data;
                    for (let i = 0; i < array.length; i++) {
                        array[i].key = i + 1;
                    }
                    console.log(array)
                    this.setState({
                        isLoaded: true,
                        list: array
                    });
                },
                // 注意：需要在此处处理错误
                // 而不是使用 catch() 去捕获错误
                // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
    }

    render() {
        return (
            <div>
                <Leftmenu />
                <div className="mainpanel">
                    <Header />
                    <PageBreadcrumb title={this.state.title}/>
                    <Content className="site-layout-background">
                        <div className="site-page-header-ghost-wrapper">
                            <PageHeader
                                ghost={false}
                                onBack={() => window.history.back()}
                                title={this.state.title}
                            >
                                <Button type="primary" onClick={onGo}>
                                    新增
                                </Button>
                                <br/>
                                <br/>
                                <Table bordered={true} columns={columns} dataSource={this.state.list}/>

                            </PageHeader>
                        </div>
                    </Content>
                </div>
            </div>
        );
    }
}

export default PageBuildAssay;


